import React from 'react'
import "./Login.css"
import {Button} from "@material-ui/core"
import {auth, provider} from "./firebase"

function Login() {

    const signIn = () => {
        // do clever things
        auth.signInWithPopup(provider)
        .catch((error)=>alert(error.message));
    }
    return (
        <div className="login">
            <h2>I am the login page</h2>
            <div className="login__logo">
                <img src="https://upload.wikimedia.org/wikipedia/commons/1/13/Discord_color_D.svg"
                     alt="">
                </img>
            </div>
            <Button onClick={signIn}>Sign In</Button>
        </div>
    )
}


export default Login
